import * as URLPattern from 'url-pattern';

import { Paths } from './routes';

document.addEventListener('DOMContentLoaded', () => {
    Paths.some(({ path, component }) => {
        const pattern = new URLPattern(path);
        const currentURL = pattern.match(window.location.pathname);
        console.log(window.location.pathname, path, currentURL)
        if (currentURL) {
            component();
        }

        return !!currentURL;
    });
});
